import React, { useState } from "react";
import { MessageCircle } from "lucide-react";
import { company } from "../mock";

const CookieBanner = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem("cookie-consent"));
  if (!visible) return null;
  const handle = (v) => { localStorage.setItem("cookie-consent", v); setVisible(false); };
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-50 bg-white rounded-2xl shadow-2xl border border-slate-100 p-5">
      <h4 className="font-display font-bold text-[#0f2846]">Rispetto della tua privacy</h4>
      <p className="text-slate-500 text-sm mt-2 leading-relaxed">
        Usiamo cookie tecnici (necessari) e, con il tuo consenso, cookie statistici e di marketing per migliorare il sito. Puoi accettare tutti o rifiutare.
      </p>
      <div className="flex gap-3 mt-4">
        <button onClick={() => handle("reject")} className="flex-1 border border-slate-200 text-slate-600 font-semibold text-sm py-2.5 rounded-lg hover:bg-slate-50 transition-colors">Rifiuta</button>
        <button onClick={() => handle("accept")} className="flex-1 bg-[#0f2846] text-white font-semibold text-sm py-2.5 rounded-lg hover:bg-[#14345a] transition-colors">Accetta tutti</button>
      </div>
    </div>
  );
};

export const WhatsAppFloat = () => (
  <a href={company.whatsappLink} target="_blank" rel="noreferrer" aria-label="WhatsApp"
    className="fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-[#22c35e] hover:bg-[#1da851] text-white flex items-center justify-center shadow-xl shadow-[#22c35e]/40 hover:scale-110 transition-transform">
    <MessageCircle size={28} fill="white" strokeWidth={0} />
    <MessageCircle size={24} className="absolute" />
  </a>
);

export default CookieBanner;
